import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const billOfMaterialsProductSideSchema = createEnum(["input", "output"]);
export type BillOfMaterialsProductSide = z.infer<
  typeof billOfMaterialsProductSideSchema
>;

const GetBillOfMaterialsSkusInput_ = z.object({
  side: billOfMaterialsProductSideSchema,
  search: z.string().optional(),
});
export const GetBillOfMaterialsSkusInput: z.ZodType<GetBillOfMaterialsSkusInput> =
  GetBillOfMaterialsSkusInput_;
export interface GetBillOfMaterialsSkusInput extends z.infer<
  typeof GetBillOfMaterialsSkusInput_
> {}

/** SKUs on the account's BOMs for one side, as the products spell them. */
export const getBillOfMaterialsSkus = {
  name: "getBillOfMaterialsSkus" as const,
  input: GetBillOfMaterialsSkusInput,
  output: z.object({ skus: z.array(z.string()) }),
};
